import { BaseClient } from '../client';

export const deleteAdminDealer = async ({ id }: { id: string }) => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return 'Apagado com sucesso';
	// }

	try {
		const response = await BaseClient.delete<string>(`/Admin/DeleteAdminConcessionaria/${id}`).then(
			(response) => response.data
		);

		return response;
	} catch (error) {
		throw error;
	}
};
